import { Dispatch, Middleware } from "redux";
import IAction from "../models/IAction";
import UserAction from "stores/user/UserAction";
import RouteEnum from "constants/RouteEnum";

const userLoggedMiddleware = (): Middleware => () => (next: Dispatch) => (action: IAction<any>): void => {
    if (action.type === "@@router/LOCATION_CHANGE") {
        let required = false;
        switch (action.payload?.location?.pathname ?? "") {
            case RouteEnum().ACCESSO_EFFETTUATO:
            case RouteEnum().DASHBOARD:
            case RouteEnum().RICHIESTA:
                //TODO redirect if not logged
                required = true;
                break;
        }
        // get token from sessionStorage and set isLogged and isLoginRequired
        next(UserAction.setUserLoginRequired(required));
    }

    next(action);
};

export default userLoggedMiddleware;
